import type { IconData } from '@stacksjs/iconify-core'

export const brush: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M416.941 27.429L185.407 219.3c-1.711-.078-3.421-.13-5.124-.13h-.025a113.88 113.88 0 0 0-108.472 78.655L18.3 461.387A26.873 26.873 0 0 0 43.771 496.6a27 27 0 0 0 8.4-1.345l163.562-53.483A113.88 113.88 0 0 0 294.388 333.3a114 114 0 0 0-.263-7.575L485.119 95.668a48.44 48.44 0 0 0-68.178-68.239M205.786 411.355L51.873 461.684L102.2 307.771a81.95 81.95 0 0 1 78.06-56.6c2.271 0 4.559.1 6.841.285l75 75a83 83 0 0 1 .285 6.842a81.95 81.95 0 0 1-56.6 78.057M460.5 75.227L277.382 295.791L216.6 235.009L437.359 52.067a16.44 16.44 0 0 1 23.141 23.16\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default brush
